import React from 'react';

export default React.createContext({
  scrollRef: null,
  setScrollRef: (height) => false,
  scrollHeight: 0,
});
